import LoginContainer from './LoginContainer';

/*
* 이메일 로그인 화면
*/
export default LoginContainer;